import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
window.$ = $;
import "./service/common.js";
import "./service/httpService.js"
import "./service/date.js"
import datepicker from 'vuejs-datepicker'; //单日期控件
import dateTimeRangePicker from "./components/dateTimeRangePicker.vue"
import askSingleton from "./components/ask/ask.js" // 询问弹窗
import "./service/validation.js" // 表单校验
Vue.prototype.$Ask = askSingleton;
import toastSingleton from "./components/toast/toast.js" // 提示弹窗
import './directives/tooltipster/tooltipster.js'; //tooltip
Vue.prototype.$Toast = toastSingleton;
Vue.prototype.$Toast = toastSingleton;
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false
Vue.component("datepicker", datepicker);
Vue.component("dateTimeRangePicker", dateTimeRangePicker);
Vue.use(VueAwesomeSwiper);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

Vue.directive('title', {
    inserted: function(el, binding) {
        document.title = el.dataset.title
    },
    update: function(el, binding) {
        document.title = el.dataset.title
    }
})